import { authRoleAccess } from 'auth/AuthRoleAccess';
import { lazy } from 'react';

const PerpetratorInformation = lazy(() => import('./PerpetratorInformation.jsx'));

const PerpetratorInformationRoutes = [
	{
		path: '/PerpetratorInformation',
		component: PerpetratorInformation,
		auth: authRoleAccess.perpetrator_information,
	},
];

export default PerpetratorInformationRoutes;
